module.exports = __webpack_public_path__ + "banquet/components/InventoryRecordDetail/images/twitter.b17c9f13e7a76383dbcdb99dac7abc7d.png";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/InventoryRecordDetail/images/twitter.png
// module id = 1674
// module chunks = 1